// extracted by mini-css-extract-plugin
export default {"wrapper":"portWidget_wrapper__JiqQ7","clickedButton":"portWidget_clickedButton__S2RUc"};